import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AuthKey } from "../components/header";

import "./shippinglabel.scss";

export default function ShippingLabel() {
  const [labelUrl, setLabelUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const shipmentId = new URLSearchParams(useLocation().search)?.get('shipmentId');

  useEffect(() => {
    async function fetchShipment() {
      try {
        await fetch("https://7xy9woipl7.execute-api.us-west-2.amazonaws.com/prod/getShipment?marker=" + AuthKey + '&shipmentId=' + shipmentId, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: ''
        })
        .then((res) => res.json())
        .then((data) => {
          setLabelUrl(data?.postage_label?.label_url);
          setLoading(false);
        });
      }
      catch (err) {
        alert("An error occurred while retrieving the shipment: " + err);
      }
    }
    if (loading)
      fetchShipment();
  }, [labelUrl, loading, shipmentId]);

  return (
    <div width="100%" style={{ marginTop: "-60px", textAlign: "center" }}>
      <img src={labelUrl} alt="Shipping Label" style={{ height:"600px", rotate: "-90deg" }} />
    </div>
  );
};

